const EmrysPay = () => {
    return (
        <div>
            <h1>Emrys Pay</h1>
        </div>
    );
};

export default EmrysPay;
